import React from 'react';
import { styled } from '@this/constants/themes';
import type { LegJson } from '@this/src/domain/select_repository';
import type SegmentClass from '@this/src/domain/transit/segment';
import TravelModeIcon from '../shared/TravelModeIcon';
import { TransitCompanyImage } from '../../shared/TransitCompanyImage';

interface PackageRouteInfoProps {
  leg: LegJson;
  legIndex: number;
  segment: SegmentClass;
  segmentIdx: number;
  hasAir: boolean;
}

const PackageRouteInfo: React.FC<PackageRouteInfoProps> = ({ leg, legIndex, segment, segmentIdx, hasAir }) => {
  return (
    <StyledSummary>
      <StyledBoxContent>
        <StyledLegTime>{leg.from.time}</StyledLegTime>
        <StyledBoxTitle>出発</StyledBoxTitle>
        <StyledSpace
          className={
            hasAir || leg.type === 'shin' || leg.type === 'express'
              ? 'select-transport-box__button_exist_leg_station'
              : ''
          }
        >
          <StyledName>{leg.from.name}</StyledName>
        </StyledSpace>
      </StyledBoxContent>

      <StyledBoxContent>
        <StyledLegTimeSpace />
        <TravelModeIcon type={segment.type} />
        <StyledSpace>
          {leg.airline_name && `${leg.airline_name} `}
          {leg.name}
        </StyledSpace>
        <StyledImageBox>
          <TransitCompanyImage src={segment.imagePathByIndex(segmentIdx)} alt="" />
        </StyledImageBox>
      </StyledBoxContent>

      <StyledBoxContent>
        <StyledLegTime>{leg.to.time}</StyledLegTime>
        <StyledBoxTitle>到着</StyledBoxTitle>
        <StyledSpace
          className={
            hasAir || leg.type === 'shin' || leg.type === 'express'
              ? 'select-transport-box__button_exist_leg_station'
              : ''
          }
        >
          <StyledName>{leg.to.name}</StyledName>
        </StyledSpace>
      </StyledBoxContent>

      <StyledBoardingArrival className="select-transport-box__left__boarding-arrival">
        {segment.shouldShowBoardingStation() &&
          legIndex === 0 && [`乗車駅：${segment.boardingName()}`, <br key={0} />]}
        {segment.shouldShowArrivalStation() &&
          legIndex === segment.legs.length - 1 &&
          `降車駅：${segment.arrivalName()}`}
      </StyledBoardingArrival>
    </StyledSummary>
  );
};

const StyledSummary = styled.div`
  padding: 0;
  margin: 0;
  display: block;
  padding: 2px 5px 2px 10px;
`;

const StyledName = styled.div`
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
`;

const StyledLegTime = styled.div`
  min-width: 50px;
  color: #3675ff;
  font-size: 13px;
  height: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  @media screen and (max-width: 768px) {
    min-width: 40px;
  }
`;

const StyledLegTimeSpace = styled.div`
  min-width: 50px;
  color: #3675ff;
  font-size: 13px;
  height: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  @media screen and (max-width: 768px) {
    min-width: 0;
  }
`;

const StyledBoxTitle = styled.div`
  background: #aaa;
  color: white;
  margin-right: 10px;
  width: 40px;
  height: 20px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const StyledBoxContent = styled.div`
  display: flex;
  padding: 5px;
`;

const StyledImageBox = styled.div`
  display: flex;
  min-width: 20px;
  margin-right: 5px;
`;

const StyledSpace = styled.div`
  margin-right: 10px;
  min-width: 15px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
`;

const StyledBoardingArrival = styled.div`
  font-size: 14px;
`;

export default PackageRouteInfo;
